/**
 * A header form for assigning new content
 */
import * as React from "react";

import type {NewAssignmentSubmitParameters} from "@khan/assignments-types";
import {StoreProvider} from "@khan/class-store";

import CreateAssignmentModalLauncher from "./create-assignment-modal-launcher.tsx";

interface Props {
    contentDescriptors: Array<string>;
    classroomDescriptor: string;
    studentKaids: Array<string>;
    onSuccess?: () => unknown;
    onClose?: () => unknown;
    onSubmit?: (params: NewAssignmentSubmitParameters) => unknown;
}

const CreateAssignmentModalProvider = ({
    contentDescriptors,
    classroomDescriptor,
    studentKaids,
    onSuccess,
    onClose,
    onSubmit,
}: Props): React.ReactElement => {
    return (
        <StoreProvider>
            {/* This needs to be wrapped with StoreProvider since this
            is async loaded in async-assignment-modal.js
            */}
            <CreateAssignmentModalLauncher
                contentDescriptors={contentDescriptors}
                classroomDescriptor={classroomDescriptor}
                studentKaids={studentKaids}
                onSuccess={onSuccess}
                onClose={onClose}
                onSubmit={onSubmit}
            />
        </StoreProvider>
    );
};

export default CreateAssignmentModalProvider;
